"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = exports.SUPPORTED_NETWORKS = exports.ONE_YEAR_MS = exports.ONE_DAY_MS = exports.ONE_HOUR_MS = exports.ONE_MIN_MS = void 0;
const arbitrum_config_1 = require("./network/arbitrum.config");
const binance_config_1 = require("./network/binance.config");
const ethereum_config_1 = require("./network/ethereum.config");
const polygon_config_1 = require("./network/polygon.config");
exports.ONE_MIN_MS = 60 * 1000;
exports.ONE_HOUR_MS = 60 * exports.ONE_MIN_MS;
exports.ONE_DAY_MS = 24 * exports.ONE_HOUR_MS;
exports.ONE_YEAR_MS = 365 * exports.ONE_DAY_MS;
exports.SUPPORTED_NETWORKS = [
    ethereum_config_1.ETH_CONFIG,
    binance_config_1.BSC_CONFIG,
    polygon_config_1.MATIC_CONFIG,
    arbitrum_config_1.ARB_CONFIG,
];
exports.VERSION = '1.0.35';
//# sourceMappingURL=constants.js.map